'use strict';

import useSubscribeAction from "~brand/features/search/hooks/useSubscribeAction";

export default function PriceTrackingButton({ routes = [] }) {
    const { subscribe, currentRoutesIsSubscribed } = useSubscribeAction({ routes })

    const isRoutesComplete = routes.every(({ from, to, date, time, seats }) => {
        return from && from.id && from.type
            && to && to.id && to.type
            && !!date && !!time && !!seats
    })

    const tooltip = currentRoutesIsSubscribed ? __('search.subscription.monitorPriceDescriptionNotActual') : __('search.subscription.monitorPriceDescriptionActual')

    if (isRoutesComplete)
        return (
            <a role='button'
                className={cn("watch-the-price el-sidebar__single", currentRoutesIsSubscribed && "active")}
                data-tooltip={tooltip}
                onClick={subscribe}
            >
                {__('search.subscription.monitorPriceText')} <i className="icon-favorite"></i>
            </a>
        )

    return null
}
